import React, { useState } from 'react'
import img from 'assets/img/mobile_money.png';
import img2 from 'assets/img/banktransfer.png';
import { AiFillCheckCircle, AiFillInfoCircle } from "react-icons/ai";
import { GrFormClose } from 'react-icons/gr'
import { BsArrowLeft } from 'react-icons/bs'
import { Box, Button, Divider } from '@mui/material';
import Btn from 'components/Btn';

function CreditModal() {
    const [type, setType] = useState('none')
    const [showReview, setShowReview] = useState(false)
    const MobileMoney = () => {
        return (
            <div className='mt-[60px] flex flex-col gap-[16px]'>
                <div className='flex flex-col gap-[8px]'>
                    <div className='text-[#657585] font-[12px]'>Account name</div>
                    <input type="text" className='p-[16px] rounded-[16px] w-[100%] bg-[#F0F3F5] border-none' placeholder='Enter account name' />
                </div>
                <div className='flex flex-col gap-[8px]'>
                    <div className='text-[#657585] font-[12px]'>Reference</div>
                    <input type="text" className='p-[16px] rounded-[16px] w-[100%] bg-[#F0F3F5] border-none' placeholder='Enter reference' />
                </div>
            </div>
        )
    }
    const BankCard = () => {
        return (
            <div className='mt-[60px] border rounded-[16px] h-[auto] p-[10px] bg-[#D3D7DB] border-[#F5F6FA] flex flex-col items-center justify-left'>
                <div className='font-[12px] flex gap-[4px] items-center'>
                    <div><AiFillInfoCircle size={12} color={'#05213D'} /></div> <div className='text-[#05213D]' style={{ fontSize: '12px' }}>You’ll be redirected to flutterwave platform to complete transaction.</div>
                </div>
                <div className='text-left w-[100%] pl-[14px]' style={{ fontSize: '12px' }}>
                    Powered by
                </div>
            </div>
        )
    }
    const Review = () => {
        return (
            <Box className={`rounded-[16px] h-[90vh] pb-[20px] bg-white ${showReview ? '' : 'hidden'}`}
                sx={{ zIndex: 1000, position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)',overflowY:'auto' ,width: { xs: '95vw', md: '50vw' } }}>

                <div className='flex items-center justify-between h-[10%] border-b-[1px]'>
                    <Button variant='standard' className='ml-[20px] text-[#1976D2] flex justify-between gap-[10px] w-[fit-content] border' onClick={() => setShowReview(false)}>
                        <div><BsArrowLeft color='#1976D2' /> </div> <div>Back</div>
                    </Button>
                    <div>
                        <GrFormClose color={'#657585'} size={30} fontWeight={300} className='m-[40px]' />
                    </div>
                </div>

                <div className='w-[100%] h-[auto] px-[40px] pt-[20px] flex'>
                    <div className='flex flex-col gap-[19px] w-[100%]'>
                        <div className='flex justify-between w-[100%] text-[24px]'>
                            <div className='text-[#657585] font-[700] '>Review</div>
                            <div className='font-[400] text-[#657585] w-[35%]' style={{fontSize:'14px'}}>Sept 22, 2021 • 16:32:34 pm</div>
                        </div>
                        <div className='flex justify-between w-[100%]'>
                            <div className='text-[#657585] font-[400]' style={{fontSize:'14px'}}>Payment method</div>
                            <div className='text-[#05213D] w-[30%]' style={{fontSize:'16px'}}>Bank transfer</div>
                        </div>
                        <div className='flex justify-between w-[100%]'>
                            <div className='text-[#657585] font-[400]' style={{fontSize:'14px'}}>Account name</div>
                            <div className='text-[#05213D] w-[30%]' style={{fontSize:'16px'}}>Name of bank account</div>
                        </div>
                        <div className='flex justify-between w-[100%]'>
                            <div className='text-[#657585] font-[400]' style={{fontSize:'14px'}}>Account number</div>
                            <div className='text-[#05213D] w-[30%]' style={{fontSize:'16px'}}>12345678901234567</div>
                        </div>
                        <div className='flex justify-between w-[100%]'>
                            <div className='text-[#657585] font-[400]' style={{fontSize:'14px'}}>Narration</div>
                            <div className='text-[#05213D] w-[30%]' style={{fontSize:'16px'}}>This is the narration</div>
                        </div>
                        <div className='flex justify-between w-[100%]'>
                            <div className='text-[#657585] font-[400]' style={{fontSize:'14px'}}>Amount</div>
                            <div className='text-[#05213D] w-[30%]' style={{fontSize:'16px'}}>NGN 200.00</div>
                        </div>
                        <div className='flex justify-between w-[100%]'>
                            <div className='text-[#657585] font-[400]' style={{fontSize:'14px'}}>Fees</div>
                            <div className='text-[#05213D] w-[30%]' style={{fontSize:'16px'}}>NGN 0.00</div>
                        </div>
                        <Divider />
                        <div className='flex justify-between w-[100%]'>
                            <div className='text-[#657585] font-[700]' style={{fontSize:'24px'}}>Total</div>
                            <div className='text-[#05213D] font-[700] w-[30%]' style={{fontSize:'24px'}}>NGN 0.00</div>
                        </div>
                        <Btn content={'Proceed to payment'} className='bg-primary py-[16px] rounded-[16px] font-[700] '  sx={{fontSize:'16px'}}/>
                    </div>
                </div>
            </Box>
        )
    }
    const proceed = () => {
        switch (type) {
            case 'mobile_money':

                break;
            case 'bank_card':
                setShowReview(true)
                break;
            default:
                break;
        }
    }
    return (
        <>
            <div className='px-[32px] py-[20px] relative'>
                <div style={{ cursor: 'pointer' }} onClick={() => setType('mobile_money')} className='flex gap-[16px] items-center justify-between  rounded-[16px] w-[100%] h-[74px] p-[14px] border'>
                    <div className='flex items-center gap-[5px] '>
                        <div>
                            <img src={img} alt="" width={24} height={24} />
                        </div>
                        <div>
                            <div className='text-[#05213D] font-[700]'>Mobile Money Transfer</div>
                            <div className='text-[#657585] text-[400]' style={{ fontSize: '12px' }}>Fund wallet using mobile money transfer</div>
                        </div>
                    </div>
                    <div>
                        <AiFillCheckCircle style={{ display: type === 'mobile_money' ? 'block' : 'none' }} color='#1976D2' size={20} />
                    </div>
                </div>
                <div style={{ cursor: 'pointer' }} onClick={() => setType('bank_card')} className='flex gap-[16px] items-center justify-between rounded-[16px] w-[100%] h-[74px] p-[14px] border mt-[16px]'>
                    <div className='flex items-center gap-[5px] '>
                        <div>
                            <img src={img2} alt="" width={24} height={24} />
                        </div>
                        <div>
                            <div className='text-[#05213D] font-[700]'>Bank card</div>
                            <div className='text-[#657585] text-[400]' style={{ fontSize: '12px' }}>Fund wallet with debit/credit card</div>
                        </div>
                    </div>
                    <div>
                        <AiFillCheckCircle style={{ display: type === 'bank_card' ? 'block' : 'none' }} color='#1976D2' size={20} />
                    </div>
                </div>

                <div className={`border-t-[8px] my-[25px] absolute w-[100%] left-0 ${type === 'bank_card' || type === 'mobile_money' ? '' : 'hidden'}`}></div>
                {type === 'bank_card' ? <BankCard /> : ''}
                {type === 'mobile_money' ? <MobileMoney /> : ''}
                <div className='flex justify-between mt-[60px]'>
                    <button className='w-[47%] h-[64px]  flex items-center justify-center rounded-[16px] border border-[#1976D2] text-[#1976D2]' onClick={() => setType('none')}> Cancel</button>
                    <button className='w-[47%] h-[64px]  flex items-center justify-center rounded-[16px] bg-[#1976D2] text-white' onClick={() => proceed()}>Proceed</button>
                </div>
            </div>
            <Review />
        </>
    )
}

export default CreditModal